import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
// import { Link } from "react-router-dom";

// Components
import LocationItemList from "../LocationItemList";
import Button from "../../../../components/Button";
import Card from "../../../../components/Card";
import CardHeader from "../../../../components/CardHeader";
import GreyBackgroundPage from "../../../../components/GreyBackgroundPage";
import MediaQuery from "../../../../components/MediaQuery";

// Styled components
// const navBarHeight = 50; // in px
const LocationItemListWrapper = styled.div`
  display: flex;
  width: 100%;
  ${MediaQuery.tablet`
    flex-direction: column;
  `};
`;
const Left = styled.div`
  flex: 0.5;
  margin-right: 30px;
  ${MediaQuery.tablet`
    margin-right: 0;
    margin-bottom: 15px;
  `};
`;
const Right = styled.div`
  flex: 0.5;
`;
const ContinueButton = Button.extend`
  margin: auto;
`;
const ButtonWrapper = styled.div`
  display: flex;
  padding: 15px;
  width: 100%;
`;

const Page = ({
  isSafeToClickContinueButton,
  originSuggestions,
  destinationSuggestions,
  handleContinueButtonClick,
  handleRadioClick
}) => (
  <GreyBackgroundPage>
    <h1>We are having trouble matching a location to your search.</h1>
    <p>Please select a location from the list below </p>
    <LocationItemListWrapper>
      <Left>
        <Card>
          <CardHeader title="1. Select a Departing Location" />
          <LocationItemList
            radioButtonName="departing"
            tripType="departing"
            locations={originSuggestions}
            handleRadioClick={handleRadioClick}
          />
        </Card>
      </Left>
      <Right>
        <Card>
          <CardHeader title="2. Arrival Location" />
          <LocationItemList
            radioButtonName="arrival"
            tripType="arrival"
            locations={destinationSuggestions}
            handleRadioClick={handleRadioClick}
          />
        </Card>
      </Right>
    </LocationItemListWrapper>
    <ButtonWrapper>
      <ContinueButton
        onClick={handleContinueButtonClick}
        disabled={!isSafeToClickContinueButton}
      >
        Continue
      </ContinueButton>
    </ButtonWrapper>
  </GreyBackgroundPage>
);

Page.propTypes = {
  originSuggestions: PropTypes.array.isRequired,
  destinationSuggestions: PropTypes.array.isRequired,
  handleRadioClick: PropTypes.func.isRequired
};

export default Page;



// WEBPACK FOOTER //
// ./src/scenes/LocationSuggestionsPage/components/Page/index.js